import chipStatusColor from './chipStatusColor'
import formatJuridicParamsToApi from './formatJuridicParamsToApi'
import formatPersonalParamsToApi from './formatPersonalParamsToApi'
import formatSupplierParamsToApi from './formatSupplierParamsToApi'
import formatTemplateParamsToApi from './formatTemplateParamsToApi'
import nameWithDocument from './nameWithDocument'
import isSupplier from './isSupplier'
import isTemplate from './isTemplate'
import blockUpdate from './blockUpdate'
import typeAndSearch from './typeAndSearch'
import companyKindLabel from './companyKindLabel'
import statusLabel from './statusLabel'
import formatInternationalParamsToApi from './formatInternationalParamsToApi'

const companies = {
  blockUpdate,
  chipStatusColor,
  companyKindLabel,
  statusLabel,
  formatJuridicParamsToApi,
  formatPersonalParamsToApi,
  formatSupplierParamsToApi,
  formatTemplateParamsToApi,
  isSupplier,
  isTemplate,
  nameWithDocument,
  typeAndSearch,
  formatInternationalParamsToApi,
}

export default companies
